export function extractLastUrl(lastSuccessfulNavigation: any): string {
  return lastSuccessfulNavigation?.previousNavigation?.initialUrl?.root?.children?.primary?.segments.join('/')?? null;
}
